export { ContactsTooltip, ContactsTooltipType, getTooltipContent } from './src/contacts-tooltip';
